import { useRoutes } from 'react-router';
import { StaticController } from '../../controllers/static.controller';

export const useStaticRouter = () => {
  const staticRoutes = StaticController;

  return useRoutes(staticRoutes);
};
